/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2022
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

const defaults = {
  isFetching: false,
  error: null,
  data: null,
  timestamp: 0,
};

export default (state = defaults, action) => {
  const timestamp = new Date().getTime();
  switch (action.type) {
    case ActionTypes.DEVICE_ACTIVATION_REQUEST: {
      return { ...state, ...defaults, isFetching: true, timestamp };
    }
    case ActionTypes.DEVICE_ACTIVATION_SUCCESS: {
      return { ...state, ...defaults, data: { ...action.payload }, timestamp };
    }
    case ActionTypes.DEVICE_ACTIVATION_FAILURE: {
      return { ...state, ...defaults, error: action.payload, timestamp };
    }
    default:
      return { ...state };
  }
};
